import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { getBook } from '../lib/api';

function LibroDetail() {
  const { slug } = useParams();
  const [book, setBook] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    getBook(slug)
      .then((data) => setBook(data.book))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="page page--narrow">
        <h1>Libro no encontrado</h1>
        <Link to="/libros">Volver a libros</Link>
      </div>
    );
  }

  if (!book) return null;

  return (
    <article className="page page--narrow">
      <Seo title={book.title} description={book.synopsis} image={book.cover_url} />
      {book.cover_url && <img src={book.cover_url} alt={book.title} style={{ maxWidth: 240, borderRadius: 8 }} />}
      <h1>{book.title}</h1>
      {book.authors?.length > 0 && (
        <p>
          {book.authors.map((author, index) => (
            <React.Fragment key={author.id}>
              {index > 0 && ', '}
              <Link to={`/autores/${author.slug}`}>{author.name}</Link>
            </React.Fragment>
          ))}
        </p>
      )}
      <dl>
        {book.publisher && (<><dt>Editorial</dt><dd>{book.publisher}</dd></>)}
        {book.genre && (<><dt>Género</dt><dd>{book.genre}</dd></>)}
        {book.pages && (<><dt>Páginas</dt><dd>{book.pages}</dd></>)}
        {book.year && (<><dt>Año</dt><dd>{book.year}</dd></>)}
        {book.rating && (<><dt>Puntuación</dt><dd>{book.rating} / 5</dd></>)}
      </dl>
      {book.synopsis && <p>{book.synopsis}</p>}
    </article>
  );
}

export default LibroDetail;
